var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "id": _vm.modalId,
      "centered": "",
      "size": "md",
      "title": "Selecionar inscrição estadual",
      "hide-footer": "",
      "body-class": "p-0"
    },
    on: {
      "hidden": _vm.resetSelecao
    }
  }, [_c('div', {
    staticClass: "p-5"
  }, [_c('p', {
    staticClass: "text-justify text-muted mb-4"
  }, [_vm._v(" Este cliente possui mais de uma inscrição estadual. Selecione qual inscrição deseja utilizar nesta operação. ")]), _c('b-form-group', {
    attrs: {
      "label": "Inscrições disponíveis",
      "label-for": "selecao_ie"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "selecao_ie",
      "stacked": ""
    },
    model: {
      value: _vm.inscricaoSelecionada,
      callback: function callback($$v) {
        _vm.inscricaoSelecionada = $$v;
      },
      expression: "inscricaoSelecionada"
    }
  }, _vm._l(_vm.opcoesInscricoes, function (inscricao, index) {
    var _inscricao$endereco$l, _inscricao$endereco$n, _inscricao$endereco$b, _inscricao$endereco$c, _inscricao$endereco, _inscricao$endereco2, _inscricao$endereco$c2, _inscricao$endereco3;
    return _c('div', {
      key: 'opcao_ie_' + index,
      staticClass: "mb-3 p-3 border rounded",
      class: {
        'border-primary': _vm.inscricaoSelecionada === inscricao.value
      }
    }, [_c('b-form-radio', {
      attrs: {
        "value": inscricao.value
      }
    }, [_c('strong', [_vm._v(_vm._s(inscricao.numero_ie))]), inscricao.principal ? _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(" Principal ")]) : _vm._e()], 1), inscricao.endereco ? _c('div', {
      staticClass: "mt-2 ml-4 text-muted small"
    }, [_vm._v(" " + _vm._s((_inscricao$endereco$l = inscricao.endereco.logradouro) !== null && _inscricao$endereco$l !== void 0 ? _inscricao$endereco$l : "") + ", " + _vm._s((_inscricao$endereco$n = inscricao.endereco.numero) !== null && _inscricao$endereco$n !== void 0 ? _inscricao$endereco$n : "") + " - " + _vm._s((_inscricao$endereco$b = inscricao.endereco.bairro) !== null && _inscricao$endereco$b !== void 0 ? _inscricao$endereco$b : "") + " "), _c('br'), _vm._v(" " + _vm._s((_inscricao$endereco$c = (_inscricao$endereco = inscricao.endereco) === null || _inscricao$endereco === void 0 || (_inscricao$endereco = _inscricao$endereco.cidade) === null || _inscricao$endereco === void 0 ? void 0 : _inscricao$endereco.cidade) !== null && _inscricao$endereco$c !== void 0 ? _inscricao$endereco$c : "") + " "), (_inscricao$endereco2 = inscricao.endereco) !== null && _inscricao$endereco2 !== void 0 && (_inscricao$endereco2 = _inscricao$endereco2.cidade) !== null && _inscricao$endereco2 !== void 0 && _inscricao$endereco2.uf || inscricao.endereco.uf ? _c('span', [_vm._v(" - " + _vm._s((_inscricao$endereco$c2 = (_inscricao$endereco3 = inscricao.endereco) === null || _inscricao$endereco3 === void 0 || (_inscricao$endereco3 = _inscricao$endereco3.cidade) === null || _inscricao$endereco3 === void 0 ? void 0 : _inscricao$endereco3.uf) !== null && _inscricao$endereco$c2 !== void 0 ? _inscricao$endereco$c2 : inscricao.endereco.uf) + " ")]) : _vm._e()]) : _vm._e()], 1);
  }), 0)], 1), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('b-button', {
    staticClass: "font-weight-bold mr-2",
    attrs: {
      "variant": "clean"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide(_vm.modalId);
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    staticClass: "font-weight-bold",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.inscricaoSelecionada
    },
    on: {
      "click": _vm.confirmarSelecao
    }
  }, [_vm._v(" Confirmar ")])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };